export type Bilingual = {
  en: string
  fr: string
}

/* Homepage hero supporting paragraph. Non-breaking spaces keep
   "comme pour vos usagers" / "the people you serve" together. */
export const heroSupporting: Bilingual = {
  fr: 'BCITI | ATNA comprend vos processus, connecte l’identité, les systèmes et les données, puis y intègre l’intelligence pour simplifier les opérations et dégager plus de capacité — pour vos équipes comme pour vos usagers.',
  en: 'BCITI | ATNA understands your processes, connects identity, systems and data, then integrates intelligence into your operations to simplify how work gets done and create more capacity — for your teams and the people you serve.',
}

export type ArchitectureNodeId = 'website' | 'mobile' | 'dashboard'

export type ArchitectureNode = {
  id: ArchitectureNodeId
  title: Bilingual
  caption: Bilingual
}

export type HeroBenefit = {
  id: 'teams' | 'costs' | 'data' | 'people'
  title: Bilingual
  caption: Bilingual
}

// Shared foundation of the hero architecture: verified identity + context.
export const heroIdentity = {
  title: {
    en: 'Digital Card',
    fr: 'Carte numérique',
  },
  caption: {
    en: 'Verified identity and unified context',
    fr: 'Identité vérifiée et contexte unifié',
  },
  chips: [
    {
      en: 'Profile',
      fr: 'Profil',
    },
    {
      en: 'Consents',
      fr: 'Consentements',
    },
    {
      en: 'Access rights',
      fr: 'Droits d’accès',
    },
  ] as Bilingual[],
}

// Entry points connected to the shared identity foundation.
export const architectureNodes: ArchitectureNode[] = [
  {
    id: 'website',
    title: {
      en: 'Website',
      fr: 'Site web',
    },
    caption: {
      en: 'Inform and interact',
      fr: 'Informer et interagir',
    },
  },
  {
    id: 'mobile',
    title: {
      en: 'Mobile app',
      fr: 'Application mobile',
    },
    caption: {
      en: 'Everyday access',
      fr: 'Au quotidien',
    },
  },
  {
    id: 'dashboard',
    title: {
      en: 'Dashboard',
      fr: 'Tableau de bord',
    },
    caption: {
      en: 'Decisions and insights',
      fr: 'Décisions et indicateurs',
    },
  },
]

export const atnaNode = {
  title: {
    en: 'Agentic intelligence',
    fr: 'Intelligence agentique',
  },
  verbs: [
    {
      en: 'Understands',
      fr: 'Comprend',
    },
    {
      en: 'Orchestrates',
      fr: 'Orchestre',
    },
    {
      en: 'Verifies',
      fr: 'Vérifie',
    },
    {
      en: 'Executes',
      fr: 'Exécute',
    },
  ] as Bilingual[],
}

export const heroBenefits: HeroBenefit[] = [
  {
    id: 'teams',
    title: {
      en: 'Empowered teams',
      fr: 'Des équipes libérées',
    },
    caption: {
      en: 'More time for what matters',
      fr: 'Plus de temps pour ce qui compte',
    },
  },
  {
    id: 'costs',
    title: {
      en: 'Controlled costs',
      fr: 'Des coûts maîtrisés',
    },
    caption: {
      en: 'Fewer systems, greater efficiency',
      fr: 'Moins de systèmes, plus d’efficacité',
    },
  },
  {
    id: 'data',
    title: {
      en: 'Protected data',
      fr: 'Des données protégées',
    },
    caption: {
      en: 'Trust and compliance',
      fr: 'Confiance et conformité',
    },
  },
  {
    id: 'people',
    title: {
      en: 'Better-served communities',
      fr: 'Des citoyens et clients mieux servis',
    },
    caption: {
      en: 'Simple, seamless experiences',
      fr: 'Des expériences simples et fluides',
    },
  },
]
